import { Container, Typography } from "@mui/material";
import React from "react";

function FallBack() {
  return (
    <Container
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
      }}
    >
      <Typography variant="h5" sx={{ fontWeight: "bold" }}>
        Oops, Something went Wrong!
      </Typography>
      <Typography variant="body1">
        Please check you internet connection. 
      </Typography>
    </Container>
  );
}

export default FallBack;
